// extracted by mini-css-extract-plugin
module.exports =  {"layout":"layout__rXKBD","errorLayout":"errorLayout__kBqeu","mainLayout":"mainLayout__Uu-nI"};